module.exports = __webpack_public_path__ + "img/3117828.png";